import string2xml from './string2xml';
export default string2xml;